import { Response } from '@angular/http';
import { Router } from '@angular/router';
import { SettingsService } from '../shared/services';
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { AppPageComponent } from '../../shared/ui/app-page/app-page.component';
import { TopLevelComponent, User } from '../../shared/models';
import { AuthService, Store, StoreHelper, UserService } from '../../shared/services';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { UpdatePasswordModel, DetailedResponse } from '../shared/models';

@Component({
    template: require('./change-password.component.pug'),
    styles: [ require('./change-password.component.scss')],
})
export class ChangePasswordComponent extends TopLevelComponent implements OnInit, OnDestroy {
    @ViewChild(AppPageComponent) appPage;

    fg: FormGroup = new FormGroup({});

    subs: Subscription[] = [];
    animation = 'fadeIn';

    error = false;
    loading = false;

    changinPassword = true;

    errorMessage: string = '';

    private _user: User;

    constructor(store: Store,
                storeHelper: StoreHelper,
                userService: UserService,
                private _authService: AuthService,
                private _settingsService: SettingsService,
                private _router: Router) {
        super(store, storeHelper, userService);
        this.headerTitle = 'Change Password';
        this.headerActions = [{ id: 'none', icon: 'none' }];
        this.subs.push(this.userService.user$.subscribe(user => this._user = user));
    }

    ngOnInit() {
        this.appPage.deactivatePreloader();
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe);
    }

    changePassword() {
       this.error = false;

       if (!this._formValid()) {
        return;
       }

       let passwordInfo = new UpdatePasswordModel({
           currentPassword: this.fg.value.currentPassword,
           newPassword: this.fg.value.newPassword,
       });

       this.appPage.activatePreloader();

       let that = this;

       this.subs.push(this._settingsService.setUserPassword(passwordInfo)
            .subscribe(
                r => that._handleSuccessResponse(r, passwordInfo),
                err => that._handleHttpError(err),
                () => that.loading = false
        ));
    }

    _formValid(): Boolean {
        if (this.fg.value.newPassword !== this.fg.value.confirmPassword) {
            this._displayError('New password and confirmation doesn\'t match');
            return false;
        }
        return true;
    }

    _handleSuccessResponse(res: DetailedResponse, passwordInfo: UpdatePasswordModel) {
       if (res.success) {
          this._reauthenticate(passwordInfo);
          return;
       }

       this._displayError(JSON.stringify(res.errors['password']));
       this.appPage.deactivatePreloader();
       this.loading = false;
    }

    _handleHttpError(res: Response) {
        this._displayError('Connection Error, try again');
        this.loading = false;
        this.appPage.deactivatePreloader();
    }

    goToSettings() {
       this.navigate('/settings');
    }

    navigate(route: string) {
        this._router.navigate([route]);
    }

    _displayError(error: string) {
         this.errorMessage = error;
         this.error = true;
    }

    _reauthenticate(passwordInfo: UpdatePasswordModel) {
        let creds = {
            account: this._user.tenant.substr(4),
            username: this._user.name,
            password: passwordInfo.newPassword
        };

        this.subs.push(this._authService.authenticate(creds)
        .subscribe(
            res => this._onSuccesfullAuth(res),
            err => this._onErrorAuth(err),
            () => console.log('ReAuth completed')
        ));
  }

  private _onSuccesfullAuth(res) {
      this.error = false;
      this.changinPassword = false;
      this.appPage.deactivatePreloader();
  }

  private _onErrorAuth(res) {
      this._displayError('There was an error authenticating new credentials, you will be redirected to the login');
      this.changinPassword = false;
      this.appPage.deactivatePreloader();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/change-password/change-password.component.ts